// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(app-application-notes) {
  margin-bottom: 5px;
}

.note {
  background-color: white;
  margin-bottom: 5px;
  padding: 5px;
  position: relative;
}

.userLabel {
  margin-top: 5px;
  font-size: 12px;
  color: #b2b2b2;
  padding: 0;
}

.dateLabel {
  font-size: 12px;
  color: #b2b2b2;
  padding: 0;
}

.descriptionLabel {
  font-size: 12px;
  color: #000;
  font-weight: 300;
  padding: 0;
}

.note:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  border-width: 0 15px 15px 0;
  border-style: solid;
  border-color: #f3f3f3 #f3f3f3 var(--theme-main-border-color, #055C8D) var(--theme-main-border-color, #055C8D);
  background: var(--theme-main-color, #055C8D);
  display: block;
  width: 0;
}

.note-container {
  overflow-y: scroll;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
